module.exports = __webpack_public_path__ + "img/logo.c054b7eb.svg";